import React, {Component} from 'react'
import { BaseTemplateStyle } from './../../../../../styles'
import { SimpleSlider } from './../../../../../components'
import { getAverageColor } from './../../../../../helpers/getAverageColor'

export default class BaseTemplate extends Component {

  state = {
    color: null
  }

  componentDidMount() {
    if (this.props.fields.image && this.props.fields.image.type === 'file' ) this.updateAverageColor(this.props)
  }

  updateAverageColor = ({fields}) => {
    getAverageColor(fields.image && fields.image.type === 'file' ? fields.image.url : null).then((data) => {
      this.setState({
        color: data
      })
    }).catch((e) => {
      console.log(e)
    })
  }
  
  render () {
    const {type, title, fields, isBrand, subtitle, category} = this.props
    const {color} = this.state
    return (
      <div className={`product-template--base ${BaseTemplateStyle(
          fields.image && fields.image.type === 'file' ? fields.image.url : '', type, color
        )}`}>
        <div className="template-scroll">
          <div className="template-left template-picture">
            {
              fields.images &&
              fields.images.length > 0 && (
                <SimpleSlider images={fields.images} />
              )
            }
          </div>
          <div className="template-right template-content">
              { category && isBrand && (<span className="title-brand">{category}</span>) }
              { title && !isBrand  && (<h2 className='subtitle'>{ title }</h2> )}
              { isBrand && subtitle  && (<h2 className={`subtitle subtitle--brand `}>{ subtitle }</h2> )}
              { title && isBrand &&  (<h3 className="subtitle-h3"> {title} </h3>)}
              { fields.description && ( <div className="content" dangerouslySetInnerHTML={{__html: fields.description}} /> )}
              { fields.titleBis && ( <h2 className="subtitle">{fields.titleBis}</h2> )}
              { fields.descriptionBis && ( <div className="content" dangerouslySetInnerHTML={{__html: fields.descriptionBis}} /> )}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Product/ProductTemplates/BaseTemplate.js